// extracted by mini-css-extract-plugin
export default {"removeAddressOverlay":"address-book-modal-remove-overlay_removeAddressOverlay__c27e2","overlayContent":"address-book-modal-remove-overlay_overlayContent__5c642"};